module.exports = __webpack_public_path__ + "static/media/emoticon-smile.91fef47b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emoticon-smile.svg
// module id = 227
// module chunks = 0